import {ReactElement, ReactNode} from "react"
import {InputType} from "@/components/forms/_form-helpers"
import {InputCheckbox, InputDate, InputSelect, InputTextMultiLine, InputTextSingleLine} from "@/components/forms/form-inputs"
import {KeyValue} from "@/library/utilities/general"

const elementFunctions: {
    [key: number]: (
        props: FormInputProps,
        key?: any,
        currentValue?: string,
        updateValue?: (newValue: any, props: FormInputProps) => void
    ) => ReactNode | ReactElement
} = {
    [InputType.TEXT_SINGLE_LINE]: InputTextSingleLine,
    [InputType.TEXT_MULTI_LINE]: InputTextMultiLine,
    [InputType.SELECT]: InputSelect,
    [InputType.DATE]: InputDate,
    [InputType.DATE_TIME]: InputDate,
    [InputType.DATE_TIME_LOCAL]: InputDate,
    [InputType.CHECKBOX]: InputCheckbox,
}

export type FormInputProps = {
    type?: InputType
    name: string
    placeholder?: string
    optional?: boolean
    tabIndex?: number
    title?: string
    pattern?: string
    onChange?: (value: any) => void
    valueType?: 'string' | 'number' | 'boolean'
    options?: KeyValue<string>
    alt?: string
    rows?: number
    cols?: number
}

export default function FormInput(
    props: FormInputProps,
    key?: any,
    currentValue?: string,
    updateValue?: (newValue: any, props: FormInputProps) => void
) {
    const {type = InputType.TEXT_SINGLE_LINE, ...remaining} = props

    if (!Object.keys(elementFunctions).includes(type.toString()))
        return <p key={key}>{InputType[type]}</p>

    return elementFunctions[type](remaining, `elementkey.${props.name}`, currentValue, updateValue)
}
